<template>
  <div class="animated fadeIn">
    <component-header
      title="FAQ Master Config"
      :isLoading="loading"
      @search-query="(val) => (filter = val)"
      @create-press="$router.push({ name: 'CreateFaq' })"
      @reload-data="getFaqsList"
      :hasClear="false"
    />
    <b-card class="card-wrap" border-variant="info">
      <div class="mt-2 faqdetailTable">
        <b-table
          style="border-radius: 12px"
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          id="my-table"
          :current-page="currentPage"
          :per-page="perPage"
          :items="faqs"
          thead-class="header"
          class="mt-3 tableRadius"
          :fields="Columns"
          show-empty
          :busy="loading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="action" slot-scope="data">
            <div class="inline_btnTable">
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="primary"
                @click="navigateTo(data, 'view')"
              >
                <i class="fa fa-eye"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 button-circle"
                style="background: #fe7b08; border: #fe7b08;"
                variant="primary"
                @click="navigateTo(data, 'edit')"
              >
                <i class="fas fa-pencil-alt edit"></i>
              </b-button>
              <b-button
                size="sm"
                class="mr-2 button-circle"
                variant="danger"
                @click="deleteFaq(data)"
              >
                <i class="fa fa-trash bin"></i>
              </b-button>
            </div>
          </template>
        </b-table>
      </div>
      <div style="float: right" v-if="faqs.length > perPage">
        <b-pagination
          v-model="currentPage"
          :per-page="perPage"
          :total-rows="faqs.length"
          aria-controls="my-table"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        ></b-pagination>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebButton from "@/components/FormElements/Button";
import loader from "@/components/loader/nipigeloader.vue";
import createfaq from "@/components/MasterSetup/FAQ/CreateFaq.vue";
import editfaq from "@/components/MasterSetup/FAQ/EditFaq.vue";
import viewfaq from "@/components/MasterSetup/FAQ/ViewFaq.vue";
import ComponentHeader from "@/components/componentNewHeader";
export default {
  name: "faqdetails",
  components: {
    ebButton,
    loader,
    createfaq,
    editfaq,
    viewfaq,
    ComponentHeader,
  },
  data() {
    return {
      filter: "",
      loading: false,
      perPage: 5,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      dark: false,
      fixed: false,
      currentPage: 1,
      context: "Add",
      faqModal: false,
      header: "Edit Faq",
      sortBy: "createdAt",
      sortDesc: true,
      faq: {},
      Columns: [
        {
          key: "category",
          sortable: true,
        },
        {
          key: "Topic",
        },
        {
          key: "Description",
        },

        {
          key: "action",
        },
      ],
    };
  },
  computed: {
    faqs() {
      let data = this.$store.getters["faq/GetFaqList"];
      let faqList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.map((obj) => {
          for (let i = 0; i < obj.items.length; i++) {
            let arrayObj = {
              _id: obj._id,
              category: obj.category,
              Topic: obj.items[i].topic,
              Description: obj.items[i].description,
              item_id: obj.items[i]._id,
              ...obj,
            };
            faqList.push(arrayObj);
          }
        });
        return faqList.filter((el) =>
          el.Topic.toLowerCase().includes(this.filter.toLowerCase())
        );
      } else {
        this.loading = false;
        return [];
      }
    },
  },
  methods: {
    async getFaqsList() {
      this.loading = true;
      await this.$store.dispatch("faq/fetchFaqsList").then((data) => {
        if (data.message) {
          this.$toasted.error(data.message);
          this.loading = false;
        } else {
          this.loading = false;
        }
      });
    },
    navigateTo(data, type) {
      let obj = {
        ...data.item,
      };
      data.item.items.forEach((el) => {
        if (data.item.item_id === el._id) {
          obj.mediaType = el.media.mediaType;
          obj.mediaContent = el.media.mediaContent;
        }
      });
      this.$store.dispatch("faq/sendFaqData", obj);
      if (type === "edit") {
        this.$router.push({ name: "EditFaq" });
        return;
      }
      if (type === "view") {
        this.$router.push({ name: "ViewFaq" });
        return;
      }
    },
    async deleteFaq(data) {
      this.$swal({
        title: "Delete this FAQ?",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("faq/deleteFaq", data.item._id + "/" + data.item.item_id)
            .then((result) => {
              this.$toasted.success("Faq Deleted Successfully");
              this.$store
                .dispatch(
                  "faq/fetchFaqsList",
                  this.$store.getters["auth/getUserID"]
                )
                .catch((error) => {
                  this.$toasted.error(error.message);
                });
            });
        }
      });
      this.$store.dispatch(
        "faq/fetchFaqsList",
        this.$store.getters["auth/getUserID"]
      );
    },
    clearModal() {
      this.faqModal = false;
      this.faq = {};
    },
  },
  async mounted() {
    // await this.$store.dispatch("faq/fetchFaqsList").then((data) => {
    //   if (data.message) {
    //     this.$toasted.error(data.message);
    //   } else {
    //   }
    // });
    this.getFaqsList();
  },
};
</script>
<style scoped>
.edit {
  color: white !important;
}
.text-center {
  text-align: center;
}
.form-div label {
  margin-top: 8px;
}
.faqdetailTable >>> .table th {
  min-width: 100%;
}
</style>
